export const WelcomePageSection = {
  welcomeContainerHeader: 'All Your Tools, One Place',
  welcomeContainerContent:
    'DaS FinSuite is the single pane of glass for Devices & Services Finance — a unified platform where 50+ financial tools, planning applications, and analytics live side by side, eliminating the need to context-switch across systems. Built by the DaS FinTech team, it delivers a seamless, embedded experience that puts everything finance teams need to plan, analyze, and act in one place.'
};
